import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import styled, { withTheme } from 'styled-components';
import CampaignMain from '../../../internal/Campaign';
import Container from '../../../components/Container';
import LayoutDefault from '../../../components/LayoutDefault';
import Navigation from '../../../components/Navigation';
var BackgroundContainer = styled(Container).withConfig({
  displayName: "Campaign__BackgroundContainer",
  componentId: "sc-89p60u-0"
})(["background-image:url(", ");background-position:center;background-size:cover;background-repeat:no-repeat;padding:", ";min-height:", ";> div{padding:", ";max-width:1160px;width:100%;margin:0 auto;background-color:", ";border-radius:4px;}@media screen and (max-width:800px){padding:", ";width:100%;max-width:100%;}"], function (props) {
  return props.backgroundImage;
}, function (props) {
  return props.backgroundImage ? '40px 20px' : '0';
}, function (props) {
  return props.backgroundImage ? '200px' : '0';
}, function (props) {
  return props.backgroundImage ? '20px' : '0';
}, function (_ref) {
  var theme = _ref.theme,
      backgroundImage = _ref.backgroundImage;
  return backgroundImage ? theme.primaryColor : 'transparent';
}, function (props) {
  return props.backgroundImage ? '10px' : '0';
});
var BackgroundContainerTop = styled(BackgroundContainer).withConfig({
  displayName: "Campaign__BackgroundContainerTop",
  componentId: "sc-89p60u-1"
})(["background-color:", ";height:", ";max-height:", ";margin-bottom:", ";@media screen and (max-width:800px){height:", ";}@media screen and (max-width:800px) and (max-height:720px){height:", ";}@media screen and (max-width:800px) and (max-height:530px){height:", ";}"], function (_ref2) {
  var theme = _ref2.theme,
      backgroundImage = _ref2.backgroundImage;
  return backgroundImage ? theme.primaryColor : 'transparent';
}, function (props) {
  return props.backgroundImage ? '100vh' : '40px';
}, function (props) {
  return props.backgroundImage ? '700px' : '40px';
}, function (props) {
  return props.backgroundImage ? '-300px' : '40px';
}, function (props) {
  return props.backgroundImage ? '60vh' : '40px';
}, function (props) {
  return props.backgroundImage ? '60vh' : '40px';
}, function (props) {
  return props.backgroundImage ? '100vh' : '40px';
});
var Wrapper = styled(Container).withConfig({
  displayName: "Campaign__Wrapper",
  componentId: "sc-89p60u-2"
})(["background-color:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.backgroundColor;
});
var CampaignContentWrapper = styled.div.withConfig({
  displayName: "Campaign__CampaignContentWrapper",
  componentId: "sc-89p60u-3"
})(["position:relative;display:flex;align-items:center;width:100%;height:auto;min-height:100vh;background-image:url(", ");background-position:center;background-size:cover;padding:160px 0;@media screen and (max-width:800px){padding:100px 0;}"], function (props) {
  return props.backgroundImage || '';
});
var CampaignContent = styled.div.withConfig({
  displayName: "Campaign__CampaignContent",
  componentId: "sc-89p60u-4"
})(["background-color:", ";display:block;position:relative;width:calc(100% - 20px);max-width:800px;margin:0 auto;padding:20px;border-radius:4px;box-shadow:", ";text-align:center;@media screen and (min-width:800px){padding:40px;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.backgroundColor;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.defaultShadow;
});

var CampaignTemplate =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(CampaignTemplate, _Component);

  function CampaignTemplate() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.childProps = function () {
      var _this$props = _this.props,
          children = _this$props.children,
          props = _objectWithoutPropertiesLoose(_this$props, ["children"]);

      return Object.assign({}, props, {}, _this.props.childProps);
    };

    _this.children = function (children) {
      if (children === void 0) {
        children = _this.props.children;
      }

      var props = _this.childProps();

      return React.Children.map(children, function (element) {
        return React.cloneElement(element, props);
      });
    };

    return _this;
  }

  var _proto = CampaignTemplate.prototype;

  _proto.render = function render() {
    var Layout = this.props.layout;
    return React.createElement(Layout, null, React.createElement(Wrapper, null, this.children()));
  };

  return CampaignTemplate;
}(Component);

CampaignTemplate.Navigation = function (_ref6) {
  var _ref6$pageContext = _ref6.pageContext;
  _ref6$pageContext = _ref6$pageContext === void 0 ? {} : _ref6$pageContext;
  var shareUrls = _ref6$pageContext.shareUrls,
      _ref6$pageContext$nod = _ref6$pageContext.node,
      node = _ref6$pageContext$nod === void 0 ? {} : _ref6$pageContext$nod;
  return React.createElement(Navigation, {
    shareUrls: shareUrls,
    items: node.menu && node.menu.items
  });
};

CampaignTemplate.Header = function (_ref7) {
  var _ref7$pageContext = _ref7.pageContext;
  _ref7$pageContext = _ref7$pageContext === void 0 ? {} : _ref7$pageContext;
  var _ref7$pageContext$nod = _ref7$pageContext.node,
      node = _ref7$pageContext$nod === void 0 ? {} : _ref7$pageContext$nod,
      children = _ref7.children;
  return React.createElement(BackgroundContainerTop, {
    backgroundImage: node.image ? node.image.url : ''
  }, children);
};

CampaignTemplate.Content = function (_ref8) {
  var node = _ref8.pageContext.node,
      children = _ref8.children;
  return React.createElement(CampaignContentWrapper, {
    backgroundImage: node && node.image && node.image.url
  }, React.createElement(CampaignContent, null, children));
};

CampaignTemplate.Main = function (props) {
  var node = props.pageContext.node;
  return React.createElement(CampaignMain, Object.assign({
    id: node.id,
    resourceType: node.resourceType,
    node: node
  }, props));
};

CampaignTemplate.defaultProps = {
  children: [React.createElement(CampaignTemplate.Navigation, null), React.createElement(CampaignTemplate.Header, null), React.createElement(CampaignTemplate.Main, null)],
  layout: LayoutDefault
};
export default withTheme(CampaignTemplate);